import Upload from "@/components/upload-comps/upload";

const DropzoneVidUploader = ({
  name,
  multiple,
  helperText,
  className,
  files,
  ...other
}) => {
  return (
    <Upload
      className={className}
      accept={{ "video/*": [] }}
      files={files}
      isImageUploader={false}
      {...other}
    />
  );
};

export default DropzoneVidUploader;
